// Static Quran metadata: surah list, juz boundaries, helpers.

export const SURAH_LIST = [
  { number: 1, name: "الفاتحة", englishName: "Al-Fatihah", ayahs: 7, type: "Meccan" },
  { number: 2, name: "البقرة", englishName: "Al-Baqarah", ayahs: 286, type: "Medinan" },
  { number: 3, name: "آل عمران", englishName: "Ali 'Imran", ayahs: 200, type: "Medinan" },
  { number: 4, name: "النساء", englishName: "An-Nisa", ayahs: 176, type: "Medinan" },
  { number: 5, name: "المائدة", englishName: "Al-Ma'idah", ayahs: 120, type: "Medinan" },
  { number: 6, name: "الأنعام", englishName: "Al-An'am", ayahs: 165, type: "Meccan" },
  { number: 7, name: "الأعراف", englishName: "Al-A'raf", ayahs: 206, type: "Meccan" },
  { number: 8, name: "الأنفال", englishName: "Al-Anfal", ayahs: 75, type: "Medinan" },
  { number: 9, name: "التوبة", englishName: "At-Tawbah", ayahs: 129, type: "Medinan" },
  { number: 10, name: "يونس", englishName: "Yunus", ayahs: 109, type: "Meccan" },
  { number: 11, name: "هود", englishName: "Hud", ayahs: 123, type: "Meccan" },
  { number: 12, name: "يوسف", englishName: "Yusuf", ayahs: 111, type: "Meccan" },
  { number: 13, name: "الرعد", englishName: "Ar-Ra'd", ayahs: 43, type: "Medinan" },
  { number: 14, name: "إبراهيم", englishName: "Ibrahim", ayahs: 52, type: "Meccan" },
  { number: 15, name: "الحجر", englishName: "Al-Hijr", ayahs: 99, type: "Meccan" },
  { number: 16, name: "النحل", englishName: "An-Nahl", ayahs: 128, type: "Meccan" },
  { number: 17, name: "الإسراء", englishName: "Al-Isra", ayahs: 111, type: "Meccan" },
  { number: 18, name: "الكهف", englishName: "Al-Kahf", ayahs: 110, type: "Meccan" },
  { number: 19, name: "مريم", englishName: "Maryam", ayahs: 98, type: "Meccan" },
  { number: 20, name: "طه", englishName: "Taha", ayahs: 135, type: "Meccan" },
  { number: 21, name: "الأنبياء", englishName: "Al-Anbya", ayahs: 112, type: "Meccan" },
  { number: 22, name: "الحج", englishName: "Al-Hajj", ayahs: 78, type: "Medinan" },
  { number: 23, name: "المؤمنون", englishName: "Al-Mu'minun", ayahs: 118, type: "Meccan" },
  { number: 24, name: "النور", englishName: "An-Nur", ayahs: 64, type: "Medinan" },
  { number: 25, name: "الفرقان", englishName: "Al-Furqan", ayahs: 77, type: "Meccan" },
  { number: 26, name: "الشعراء", englishName: "Ash-Shu'ara", ayahs: 227, type: "Meccan" },
  { number: 27, name: "النمل", englishName: "An-Naml", ayahs: 93, type: "Meccan" },
  { number: 28, name: "القصص", englishName: "Al-Qasas", ayahs: 88, type: "Meccan" },
  { number: 29, name: "العنكبوت", englishName: "Al-Ankabut", ayahs: 69, type: "Meccan" },
  { number: 30, name: "الروم", englishName: "Ar-Rum", ayahs: 60, type: "Meccan" },
  { number: 31, name: "لقمان", englishName: "Luqman", ayahs: 34, type: "Meccan" },
  { number: 32, name: "السجدة", englishName: "As-Sajdah", ayahs: 30, type: "Meccan" },
  { number: 33, name: "الأحزاب", englishName: "Al-Ahzab", ayahs: 73, type: "Medinan" },
  { number: 34, name: "سبأ", englishName: "Saba", ayahs: 54, type: "Meccan" },
  { number: 35, name: "فاطر", englishName: "Fatir", ayahs: 45, type: "Meccan" },
  { number: 36, name: "يس", englishName: "Ya-Sin", ayahs: 83, type: "Meccan" },
  { number: 37, name: "الصافات", englishName: "As-Saffat", ayahs: 182, type: "Meccan" },
  { number: 38, name: "ص", englishName: "Sad", ayahs: 88, type: "Meccan" },
  { number: 39, name: "الزمر", englishName: "Az-Zumar", ayahs: 75, type: "Meccan" },
  { number: 40, name: "غافر", englishName: "Ghafir", ayahs: 85, type: "Meccan" },
  { number: 41, name: "فصلت", englishName: "Fussilat", ayahs: 54, type: "Meccan" },
  { number: 42, name: "الشورى", englishName: "Ash-Shuraa", ayahs: 53, type: "Meccan" },
  { number: 43, name: "الزخرف", englishName: "Az-Zukhruf", ayahs: 89, type: "Meccan" },
  { number: 44, name: "الدخان", englishName: "Ad-Dukhan", ayahs: 59, type: "Meccan" },
  { number: 45, name: "الجاثية", englishName: "Al-Jathiyah", ayahs: 37, type: "Meccan" },
  { number: 46, name: "الأحقاف", englishName: "Al-Ahqaf", ayahs: 35, type: "Meccan" },
  { number: 47, name: "محمد", englishName: "Muhammad", ayahs: 38, type: "Medinan" },
  { number: 48, name: "الفتح", englishName: "Al-Fath", ayahs: 29, type: "Medinan" },
  { number: 49, name: "الحجرات", englishName: "Al-Hujurat", ayahs: 18, type: "Medinan" },
  { number: 50, name: "ق", englishName: "Qaf", ayahs: 45, type: "Meccan" },
  { number: 51, name: "الذاريات", englishName: "Adh-Dhariyat", ayahs: 60, type: "Meccan" },
  { number: 52, name: "الطور", englishName: "At-Tur", ayahs: 49, type: "Meccan" },
  { number: 53, name: "النجم", englishName: "An-Najm", ayahs: 62, type: "Meccan" },
  { number: 54, name: "القمر", englishName: "Al-Qamar", ayahs: 55, type: "Meccan" },
  { number: 55, name: "الرحمن", englishName: "Ar-Rahman", ayahs: 78, type: "Medinan" },
  { number: 56, name: "الواقعة", englishName: "Al-Waqi'ah", ayahs: 96, type: "Meccan" },
  { number: 57, name: "الحديد", englishName: "Al-Hadid", ayahs: 29, type: "Medinan" },
  { number: 58, name: "المجادلة", englishName: "Al-Mujadila", ayahs: 22, type: "Medinan" },
  { number: 59, name: "الحشر", englishName: "Al-Hashr", ayahs: 24, type: "Medinan" },
  { number: 60, name: "الممتحنة", englishName: "Al-Mumtahanah", ayahs: 13, type: "Medinan" },
  { number: 61, name: "الصف", englishName: "As-Saf", ayahs: 14, type: "Medinan" },
  { number: 62, name: "الجمعة", englishName: "Al-Jumu'ah", ayahs: 11, type: "Medinan" },
  { number: 63, name: "المنافقون", englishName: "Al-Munafiqun", ayahs: 11, type: "Medinan" },
  { number: 64, name: "التغابن", englishName: "At-Taghabun", ayahs: 18, type: "Medinan" },
  { number: 65, name: "الطلاق", englishName: "At-Talaq", ayahs: 12, type: "Medinan" },
  { number: 66, name: "التحريم", englishName: "At-Tahrim", ayahs: 12, type: "Medinan" },
  { number: 67, name: "الملك", englishName: "Al-Mulk", ayahs: 30, type: "Meccan" },
  { number: 68, name: "القلم", englishName: "Al-Qalam", ayahs: 52, type: "Meccan" },
  { number: 69, name: "الحاقة", englishName: "Al-Haqqah", ayahs: 52, type: "Meccan" },
  { number: 70, name: "المعارج", englishName: "Al-Ma'arij", ayahs: 44, type: "Meccan" },
  { number: 71, name: "نوح", englishName: "Nuh", ayahs: 28, type: "Meccan" },
  { number: 72, name: "الجن", englishName: "Al-Jinn", ayahs: 28, type: "Meccan" },
  { number: 73, name: "المزمل", englishName: "Al-Muzzammil", ayahs: 20, type: "Meccan" },
  { number: 74, name: "المدثر", englishName: "Al-Muddaththir", ayahs: 56, type: "Meccan" },
  { number: 75, name: "القيامة", englishName: "Al-Qiyamah", ayahs: 40, type: "Meccan" },
  { number: 76, name: "الإنسان", englishName: "Al-Insan", ayahs: 31, type: "Medinan" },
  { number: 77, name: "المرسلات", englishName: "Al-Mursalat", ayahs: 50, type: "Meccan" },
  { number: 78, name: "النبأ", englishName: "An-Naba", ayahs: 40, type: "Meccan" },
  { number: 79, name: "النازعات", englishName: "An-Nazi'at", ayahs: 46, type: "Meccan" },
  { number: 80, name: "عبس", englishName: "Abasa", ayahs: 42, type: "Meccan" },
  { number: 81, name: "التكوير", englishName: "At-Takwir", ayahs: 29, type: "Meccan" },
  { number: 82, name: "الانفطار", englishName: "Al-Infitar", ayahs: 19, type: "Meccan" },
  { number: 83, name: "المطففين", englishName: "Al-Mutaffifin", ayahs: 36, type: "Meccan" },
  { number: 84, name: "الانشقاق", englishName: "Al-Inshiqaq", ayahs: 25, type: "Meccan" },
  { number: 85, name: "البروج", englishName: "Al-Buruj", ayahs: 22, type: "Meccan" },
  { number: 86, name: "الطارق", englishName: "At-Tariq", ayahs: 17, type: "Meccan" },
  { number: 87, name: "الأعلى", englishName: "Al-A'la", ayahs: 19, type: "Meccan" },
  { number: 88, name: "الغاشية", englishName: "Al-Ghashiyah", ayahs: 26, type: "Meccan" },
  { number: 89, name: "الفجر", englishName: "Al-Fajr", ayahs: 30, type: "Meccan" },
  { number: 90, name: "البلد", englishName: "Al-Balad", ayahs: 20, type: "Meccan" },
  { number: 91, name: "الشمس", englishName: "Ash-Shams", ayahs: 15, type: "Meccan" },
  { number: 92, name: "الليل", englishName: "Al-Layl", ayahs: 21, type: "Meccan" },
  { number: 93, name: "الضحى", englishName: "Ad-Duhaa", ayahs: 11, type: "Meccan" },
  { number: 94, name: "الشرح", englishName: "Ash-Sharh", ayahs: 8, type: "Meccan" },
  { number: 95, name: "التين", englishName: "At-Tin", ayahs: 8, type: "Meccan" },
  { number: 96, name: "العلق", englishName: "Al-Alaq", ayahs: 19, type: "Meccan" },
  { number: 97, name: "القدر", englishName: "Al-Qadr", ayahs: 5, type: "Meccan" },
  { number: 98, name: "البينة", englishName: "Al-Bayyinah", ayahs: 8, type: "Medinan" },
  { number: 99, name: "الزلزلة", englishName: "Az-Zalzalah", ayahs: 8, type: "Medinan" },
  { number: 100, name: "العاديات", englishName: "Al-Adiyat", ayahs: 11, type: "Meccan" },
  { number: 101, name: "القارعة", englishName: "Al-Qari'ah", ayahs: 11, type: "Meccan" },
  { number: 102, name: "التكاثر", englishName: "At-Takathur", ayahs: 8, type: "Meccan" },
  { number: 103, name: "العصر", englishName: "Al-Asr", ayahs: 3, type: "Meccan" },
  { number: 104, name: "الهمزة", englishName: "Al-Humazah", ayahs: 9, type: "Meccan" },
  { number: 105, name: "الفيل", englishName: "Al-Fil", ayahs: 5, type: "Meccan" },
  { number: 106, name: "قريش", englishName: "Quraysh", ayahs: 4, type: "Meccan" },
  { number: 107, name: "الماعون", englishName: "Al-Ma'un", ayahs: 7, type: "Meccan" },
  { number: 108, name: "الكوثر", englishName: "Al-Kawthar", ayahs: 3, type: "Meccan" },
  { number: 109, name: "الكافرون", englishName: "Al-Kafirun", ayahs: 6, type: "Meccan" },
  { number: 110, name: "النصر", englishName: "An-Nasr", ayahs: 3, type: "Medinan" },
  { number: 111, name: "المسد", englishName: "Al-Masad", ayahs: 5, type: "Meccan" },
  { number: 112, name: "الإخلاص", englishName: "Al-Ikhlas", ayahs: 4, type: "Meccan" },
  { number: 113, name: "الفلق", englishName: "Al-Falaq", ayahs: 5, type: "Meccan" },
  { number: 114, name: "الناس", englishName: "An-Nas", ayahs: 6, type: "Meccan" },
];

export const JUZ_DATA = [
  { juz: 1, start: { surah: 1, ayah: 1 }, end: { surah: 2, ayah: 141 } },
  { juz: 2, start: { surah: 2, ayah: 142 }, end: { surah: 2, ayah: 252 } },
  { juz: 3, start: { surah: 2, ayah: 253 }, end: { surah: 3, ayah: 92 } },
  { juz: 4, start: { surah: 3, ayah: 93 }, end: { surah: 4, ayah: 23 } },
  { juz: 5, start: { surah: 4, ayah: 24 }, end: { surah: 4, ayah: 147 } },
  { juz: 6, start: { surah: 4, ayah: 148 }, end: { surah: 5, ayah: 81 } },
  { juz: 7, start: { surah: 5, ayah: 82 }, end: { surah: 6, ayah: 110 } },
  { juz: 8, start: { surah: 6, ayah: 111 }, end: { surah: 7, ayah: 87 } },
  { juz: 9, start: { surah: 7, ayah: 88 }, end: { surah: 8, ayah: 40 } },
  { juz: 10, start: { surah: 8, ayah: 41 }, end: { surah: 9, ayah: 92 } },
  { juz: 11, start: { surah: 9, ayah: 93 }, end: { surah: 11, ayah: 5 } },
  { juz: 12, start: { surah: 11, ayah: 6 }, end: { surah: 12, ayah: 52 } },
  { juz: 13, start: { surah: 12, ayah: 53 }, end: { surah: 14, ayah: 52 } },
  { juz: 14, start: { surah: 15, ayah: 1 }, end: { surah: 16, ayah: 128 } },
  { juz: 15, start: { surah: 17, ayah: 1 }, end: { surah: 18, ayah: 74 } },
  { juz: 16, start: { surah: 18, ayah: 75 }, end: { surah: 20, ayah: 135 } },
  { juz: 17, start: { surah: 21, ayah: 1 }, end: { surah: 22, ayah: 78 } },
  { juz: 18, start: { surah: 23, ayah: 1 }, end: { surah: 25, ayah: 20 } },
  { juz: 19, start: { surah: 25, ayah: 21 }, end: { surah: 27, ayah: 55 } },
  { juz: 20, start: { surah: 27, ayah: 56 }, end: { surah: 29, ayah: 45 } },
  { juz: 21, start: { surah: 29, ayah: 46 }, end: { surah: 33, ayah: 30 } },
  { juz: 22, start: { surah: 33, ayah: 31 }, end: { surah: 36, ayah: 27 } },
  { juz: 23, start: { surah: 36, ayah: 28 }, end: { surah: 39, ayah: 31 } },
  { juz: 24, start: { surah: 39, ayah: 32 }, end: { surah: 41, ayah: 46 } },
  { juz: 25, start: { surah: 41, ayah: 47 }, end: { surah: 45, ayah: 37 } },
  { juz: 26, start: { surah: 46, ayah: 1 }, end: { surah: 51, ayah: 30 } },
  { juz: 27, start: { surah: 51, ayah: 31 }, end: { surah: 57, ayah: 29 } },
  { juz: 28, start: { surah: 58, ayah: 1 }, end: { surah: 66, ayah: 12 } },
  { juz: 29, start: { surah: 67, ayah: 1 }, end: { surah: 77, ayah: 50 } },
  { juz: 30, start: { surah: 78, ayah: 1 }, end: { surah: 114, ayah: 6 } },
];

export const getJuzForSurah = (surahNum) => {
  for (const juz of JUZ_DATA) {
    if (surahNum >= juz.start.surah && surahNum <= juz.end.surah) {
      return juz.juz;
    }
  }
  return 1;
};

const ARABIC_DIGITS = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

export const toArabicNumber = (num) =>
  String(num)
    .split("")
    .map((d) => ARABIC_DIGITS[parseInt(d, 10)] ?? d)
    .join("");

// English meaning of each surah, indexed by surah number (1..114).
export const SURAH_MEANINGS = {
  1: "The Opening",
  2: "The Cow",
  3: "The Family of Imran",
  4: "The Women",
  5: "The Table Spread",
  6: "The Cattle",
  7: "The Heights",
  8: "The Spoils of War",
  9: "The Repentance",
  10: "Jonah",
  11: "Hud",
  12: "Joseph",
  13: "The Thunder",
  14: "Abraham",
  15: "The Rocky Tract",
  16: "The Bee",
  17: "The Night Journey",
  18: "The Cave",
  19: "Mary",
  20: "Ta-Ha",
  21: "The Prophets",
  22: "The Pilgrimage",
  23: "The Believers",
  24: "The Light",
  25: "The Criterion",
  26: "The Poets",
  27: "The Ant",
  28: "The Stories",
  29: "The Spider",
  30: "The Romans",
  31: "Luqman",
  32: "The Prostration",
  33: "The Combined Forces",
  34: "Sheba",
  35: "The Originator",
  36: "Ya Sin",
  37: "Those Who Set the Ranks",
  38: "Sad",
  39: "The Troops",
  40: "The Forgiver",
  41: "Explained in Detail",
  42: "The Consultation",
  43: "The Gold Adornments",
  44: "The Smoke",
  45: "The Crouching",
  46: "The Curved Sand-Hills",
  47: "Muhammad",
  48: "The Victory",
  49: "The Rooms",
  50: "Qaf",
  51: "The Winnowing Winds",
  52: "The Mount",
  53: "The Star",
  54: "The Moon",
  55: "The Most Merciful",
  56: "The Inevitable",
  57: "The Iron",
  58: "The Pleading Woman",
  59: "The Exile",
  60: "The Examined One",
  61: "The Ranks",
  62: "The Friday",
  63: "The Hypocrites",
  64: "Mutual Disposition",
  65: "The Divorce",
  66: "The Prohibition",
  67: "The Sovereignty",
  68: "The Pen",
  69: "The Reality",
  70: "The Ascending Stairways",
  71: "Noah",
  72: "The Jinn",
  73: "The Enshrouded One",
  74: "The Cloaked One",
  75: "The Resurrection",
  76: "The Human",
  77: "The Emissaries",
  78: "The Tidings",
  79: "Those Who Drag Forth",
  80: "He Frowned",
  81: "The Overthrowing",
  82: "The Cleaving",
  83: "Defrauding",
  84: "The Splitting",
  85: "The Mansions of the Stars",
  86: "The Morning Star",
  87: "The Most High",
  88: "The Overwhelming",
  89: "The Dawn",
  90: "The City",
  91: "The Sun",
  92: "The Night",
  93: "The Morning Hours",
  94: "The Relief",
  95: "The Fig",
  96: "The Clot",
  97: "The Power",
  98: "The Clear Proof",
  99: "The Earthquake",
  100: "The Coursers",
  101: "The Calamity",
  102: "Competition",
  103: "The Time",
  104: "The Slanderer",
  105: "The Elephant",
  106: "Quraysh",
  107: "Small Kindnesses",
  108: "Abundance",
  109: "The Disbelievers",
  110: "The Help",
  111: "The Palm Fiber",
  112: "The Sincerity",
  113: "The Daybreak",
  114: "Mankind",
};
